import { render, staticRenderFns } from "./LoanCalculator.vue?vue&type=template&id=1b989e9b&scoped=true&"
import script from "./LoanCalculator.vue?vue&type=script&lang=js&"
export * from "./LoanCalculator.vue?vue&type=script&lang=js&"
import style0 from "./LoanCalculator.vue?vue&type=style&index=0&id=1b989e9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b989e9b",
  null
  
)

export default component.exports